/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import store from './redux/store';
import Routers from './router/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import TableContextProvider from './contexts/tableContext';
import { getCookies, setCookies } from './hooks/useCookies';
import envValues from './enviornment';

const APP_TITLE = 'marQ - Event Management';

const TOAST_ICON_COLORS = {
  error: '#dc2626',
  success: '#16a34a',
  warning: '#d97706',
  info: '#cd47f3',
};

const TOAST_ICON_BACKGROUNDS = {
  error: '#FEE2E2',
  success: '#DCFCE7',
  warning: '#FEF3C7',
  info: '#F3E8FF',
};

function ToastIcon({ type }) {
  const color = TOAST_ICON_COLORS[type] || TOAST_ICON_COLORS.info;
  const background = TOAST_ICON_BACKGROUNDS[type] || TOAST_ICON_BACKGROUNDS.info;

  if (type === 'success') {
    return (
      <svg className="toastIcon" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
        <circle cx="16" cy="16" r="16" fill={background} />
        <path
          d="M10.5 16.2l3.6 3.6 7.4-7.4"
          fill="none"
          stroke={color}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === 'info') {
    return (
      <svg className="toastIcon" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
        <circle cx="16" cy="16" r="16" fill={background} />
        <circle cx="16" cy="10.2" r="1.5" fill={color} />
        <path d="M16 14.2v8" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg className="toastIcon" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="16" fill={background} />
      <path d="M16 9.5v8.2" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="16" cy="22.2" r="1.45" fill={color} />
    </svg>
  );
}

function ToastCloseButton({ closeToast }) {
  return (
    <button type="button" className="toastCloseBtn" onClick={closeToast} aria-label="Close">
      <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
        <path
          d="M3 3l8 8M11 3l-8 8"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}

ToastIcon.propTypes = {
  type: PropTypes.string,
};

ToastIcon.defaultProps = {
  type: 'info',
};

ToastCloseButton.propTypes = {
  closeToast: PropTypes.func.isRequired,
};

function App() {
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    document.title = APP_TITLE;
  }, []);
  const cookieBannerControl = () => {
    setShowBanner(!showBanner);
    setCookies('showCookieBanner', false);
  };
  return (
    <Provider store={store}>
      <div className="App">
        <TableContextProvider>
          <Routers />
        </TableContextProvider>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
          icon={ToastIcon}
          closeButton={ToastCloseButton}
        />
      </div>
      {showBanner &&
      envValues.REACT_APP_SHOW_COOKIE_BOX &&
      getCookies('showCookieBanner') !== 'false' ? (
        <div className="cookie-banner">
          <p>This website uses cookies to enhance user experience.</p>
          <button type="button" className="close" onClick={cookieBannerControl}>
            I Understand
          </button>
        </div>
      ) : null}
    </Provider>
  );
}
export default App;
